export default function PaginateMore({pagination, ...props}) {
  return (
    pagination && pagination["next"] ? (
      <div className="col-span-6 text-center" key="paginate-more">
        <button onClick={() => props.onPaginationClick(pagination["next"])} className="text-sm text-green-500 hover:text-green-600">Mais</button>
      </div>
    ) : <><div className="col-span-5 italic pl-1">Início</div><div className="text-right">0</div></>
  );
}
